module.exports = __webpack_public_path__ + "img/iluarco.b096729e.png";